import { render, staticRenderFns } from "./Dos.vue?vue&type=template&id=0f591e1d&scoped=true"
import script from "./Dos.vue?vue&type=script&lang=js"
export * from "./Dos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f591e1d",
  null
  
)

export default component.exports